import { debounce } from 'lodash-es';

import { Flex, Heading } from '@chakra-ui/react';

import { ContentContainer } from '~/components/container';
import { SectionHeader } from '~/components/section-header';
import { AI_MARKETER_ANALYTICS_EVENT, COPY } from '~/features/ai-marketer/constants';
import { trackEvent } from '~/features/analytics/track-event';
import { CheckedIcon } from '~/features/experiments/ab_plp_redesign_2025/icons';
import { TestimonialCarousel } from '~/features/testimonials/components/testimonial-carousel';

const TESTIMONIAL_ROLE = 'AI Marketer Nanodegree program Beta tester';

export function AiMarketerTestimonialsSection() {
  const handleInteraction = debounce(() => {
    trackEvent({
      name: AI_MARKETER_ANALYTICS_EVENT,
      type: 'click',
      label: 'testimonial_scroll_clicked',
    });
  }, 100);

  return (
    <Flex
      as='section'
      flexDirection='column'
      gap='56px'
      padding={{
        base: '56px 0px',
        md: '112px 0px',
      }}
    >
      <ContentContainer margin='0 auto' maxWidth='766px' width='100%'>
        <SectionHeader
          color='grey.500'
          iconSlot={<CheckedIcon color='grey.500' height='18px' width='18px' />}
          subtitle={COPY.testimonials.subtitle}
          titleSlot={
            <Heading
              as='h2'
              fontWeight='600'
              lineHeight='1.1'
              fontSize={{
                base: '2.25rem',
                md: '3.375rem',
              }}
            >
              {COPY.testimonials.title}
            </Heading>
          }
        />
      </ContentContainer>
      <TestimonialCarousel
        autoplay={false}
        testimonials={[
          {
            imagePath: '/images/ai-marketer/osarenogae-ogieva-card.webp',
            labelKey: 'testimonials.osarenogaeOgieva.label',
            quoteKey: 'testimonials.osarenogaeOgieva.quote',
            name: 'Osarenogae Ogieva',
            title: TESTIMONIAL_ROLE,
            quoteColor: 'light',
            labelColor: 'light',
          },
          {
            imagePath: '/images/ai-marketer/sabrina-palis-card.webp',
            labelKey: 'testimonials.sabrinaPalisAiMarketer.label',
            quoteKey: 'testimonials.sabrinaPalisAiMarketer.quote',
            name: 'Sabrina Palis',
            title: TESTIMONIAL_ROLE,
            quoteColor: 'light',
            labelColor: 'dark',
          },
          {
            imagePath: '/images/ai-marketer/husein-kedir-kelil-card.webp',
            labelKey: 'testimonials.huseinKedirKelil.label',
            quoteKey: 'testimonials.huseinKedirKelil.quote',
            name: 'Husein Kedir Kelil',
            title: TESTIMONIAL_ROLE,
            quoteColor: 'light',
            labelColor: 'light',
          },
        ]}
        scrollOnlyOnOverflow
        onInteraction={handleInteraction}
      />
    </Flex>
  );
}
